/**
 * Generates a Vimeo embed URL for a given video ID and hash parameter.
 * @param videoId
 * @param hashParameter
 * @returns {`https://player.vimeo.com/video/${string}?h=${string}&title=0&byline=0&autoplay=1`}
 */
const generateVimeoEmbedUrl = (videoId, hashParameter) =>
  `https://player.vimeo.com/video/${videoId}?h=${hashParameter}&title=0&byline=0&autoplay=1`

export const CHOOSE_GUIDE_RESOURCE_URL = generateVimeoEmbedUrl(1164440226, "3a179a4b83")
export const INVITE_STUDENT_RESOURCE_URL = generateVimeoEmbedUrl(1164440413, "12befa074b")
export const SIT_WITH_STUDENT_RESOURCE_URL = generateVimeoEmbedUrl(1164440930, "9f847ed616")
export const INVITE_MENTORS_RESOURCE_URL = generateVimeoEmbedUrl(1164441445, "5c676e4503")
export const GREAT_MENTORS_RESOURCE_URL = generateVimeoEmbedUrl(1164441339, "289ad8c195")
export const IDENTITY_RESOURCE_URL = generateVimeoEmbedUrl(1164440575, "bc8e882bae")
export const IDENTITY_WORKSHEET_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_06_30_Encircled_IdentityActivity.pdf"
export const VISION_RESOURCE_URL = generateVimeoEmbedUrl(1164441093, "cca8b3ef9f")
export const VISION_WORKSHEET_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_06_30_Encircled_VisionActivity.pdf"
export const SERVICE_WORKSHEET_URL = "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_09_24_Service_Reflection_Worksheet.pdf"
export const SERVICE_RESOURCE_URL = generateVimeoEmbedUrl(1164441232, "2442ba545a")
export const GIFTS_RESOURCE_URL = "https://www.viacharacter.org/survey/pro/encircled/account/register"
export const GIFTS_WORKSHEET_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_06_30_Encircled_GiftsActivity.pdf"
export const MENTORS_RESOURCE_URL = generateVimeoEmbedUrl(1164441339, "289ad8c195")
export const MENTORS_WORKSHEET_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_06_30_Encircled_MentorsActivity.pdf"
export const MENTOR_CIRCLE_ACTIVITY_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/2026_06_30_Encircled_MentorCircleActivity.pdf"
export const ENCOURAGEMENT_RESOURCE_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Examples%20of%20Encouragements.pdf"
export const COMMITMENTS_RESOURCE_URL =
  "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Examples%20of%20Commitments.pdf"
export const BLESSINGS_RESOURCE_URL = generateVimeoEmbedUrl(1164441628, "aea02b4448")
export const VALUE_OF_IN_PERSON_GATHERING_RESOURCE_URL = generateVimeoEmbedUrl(1154172976, "2e0504adcc")
export const HOW_IT_WORKS_RESOURCE_URL = generateVimeoEmbedUrl(1164439753, "8cb14c7e4c")
export const KEEP_MOMENTUM_RESOURCE_URL = generateVimeoEmbedUrl(1164441709, "ad0cf7b257")


export const RESOURCES = [
  {
    groupName: "Students",
    resourceGroups: [
      {
        name: "Videos",
        resources: [
          {
            name: "The Impact of Knowing Who You Are in Jesus",
            copy: "A brief video on how understanding your identity in Jesus brings clarity, confidence, and purpose to how you live and lead.",
            url: generateVimeoEmbedUrl(1143226179, "aaa827ee2e"),
            type: "Video",
          },
          {
            name: "The Power of Having a Vision",
            copy: "A short video guiding students on how to thoughtfully choose mentors who will support, encourage, and walk with them well.",
            url: generateVimeoEmbedUrl(1143236549, "da1ef4b9ac"),
            type: "Video",
          },
          {
            name: "How Service Strengthens Mentor Circles",
            copy: "A short video on how having a clear vision brings direction and hope for the future.",
            url: generateVimeoEmbedUrl(1143245916, "8efbb5c4e7"),
            type: "Video",
          },
          {
            name: "How to Pick Your Mentors",
            copy: "A short video exploring how service deepens relationships, builds purpose, and strengthens Mentor Circles.",
            url: generateVimeoEmbedUrl(1164441339, "289ad8c195"),
            type: "Video",
          },
        ],
      },
      {
        name: "Getting Started",
        resources: [
          {
            name: "God-Given Gifts Activity",
            copy: "A simple self-guided activity that helps students discovery their God-Given Gifts.",
            type: "PDF",
          },
          {
            name: "VIA Strengths Assessment (10 min)",
            copy: "A free, 10-minute survey that helps students understand learn more about their unique God-Given Gifts.",
            url: "https://encircled.pro.viasurvey.org/",
            type: "Link",
          },
          {
            name: "Popular Life Areas for Students",
            copy: "A simple overview of common life areas that help students reflect, set goals, and see their life more clearly.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Popular%20Life%20Areas%20for%20Young%20Adults.pdf",
            type: "PDF",
          },
          {
            name: "Examples of 1-Year Goals",
            copy: "A practical set of examples to help students understand what clear, achievable 1-year goals can look like.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Examples%20of%201%20Year%20Goals.pdf",
            type: "PDF",
          },
        ],
      },
    ],
  },
  {
    groupName: "Guides",
    resourceGroups: [
      {
        name: "Videos",
        resources: [
          {
            name: "How to Sit with a Student",
            copy: "A practical walkthrough showing how to lead a student through the activities clearly, confidently, and with purpose.",
            url: SIT_WITH_STUDENT_RESOURCE_URL,
            type: "Video",
          },
          {
            name: "What is a Guide and How to Become One",
            copy: "A short overview of the Guide role, what it involves, and how to take the next step to become one.",
            url: CHOOSE_GUIDE_RESOURCE_URL,
            type: "Video",
          },
        ],
      },
      {
        name: "Facilitation Materials",
        resources: [
          {
            name: "Guide Handbook",
            copy: "The Guide Handbook gives you clear, practical guidance for leading a Mentor Circle and supporting students well. It’s a simple, go-to resource to help you know what to do and feel confident doing it.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Guide%20Handbook.pdf",
            type: "PDF",
          },
          {
            name: "Facilitation Slides (PDF)",
            copy: "A flexible, easy-to-follow guide you can use both to prepare in advance or present directly during a session.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Facilitator%20Slides.pdf",
            type: "PDF",
          },
          {
            name: "Facilitation Slides (PPTX)",
            copy: "A ready-to-use slide deck designed for live facilitation, helping you guide the session smoothly and keep everyone aligned.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Facilitator%20Slides.pptx",
            type: "PPTX",
          },
        ],
      },
    ],
  },
  {
    groupName: "Mentors",
    resourceGroups: [
      {
        name: "Mentor Resources",
        resources: [
          {
            name: "The Power of Giving a Blessing",
            url: generateVimeoEmbedUrl(1143319257, "a5f2ab09a0"),
            type: "Video",
          },
          {
            name: "Working with Students Who are Carrying A Lot",
            url: generateVimeoEmbedUrl(1164440720, "558880d07c"),
            type: "Video",
          },
          {
            name: "Examples of Encouragements",
            url: "",
            type: "PDF",
          },
          {
            name: "How to Give and Receive Blessing",
            urls: [
              "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20Examples%20of%20Encouragements.pdf",
              "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Personal%20Journey%20-%20How%20to%20Give%20and%20Receive%20Blessings.pdf",
            ],
            type: "PDF",
          },
        ],
      },
      {
        name: "Additional Mentor Resources",
        resources: [
          {
            name: "Mentor Essentials 1-Pager - High School",
            copy: "A one-page guide outlining how mentors can encourage, support, and stay engaged with high school students.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Mentor%20Essentials%20-%20High%20School.pdf",
            type: "PDF",
          },
          {
            name: "Mentor Essentials 1-Pager - Middle School",
            copy: "A one-page guide with practical tips for mentoring middle school students with clarity and care.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Mentor%20Essentials%20-%20Middle%20School.pdf",
            type: "PDF",
          },
          {
            name: "Mentor Essentials 1-Pager - K-5th Grade",
            copy: "A one-page guide focused on simple, age-appropriate ways mentors can support elementary-aged students.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Mentor%20Essentials%20-%20K-5th%20Grade.pdf",
            type: "PDF",
          },
          {
            name: "Mentor Essentials: 0-5 Year Olds",
            copy: "A concise guide on how mentors can help support a child and family in the earliest years.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Mentor%20Essentials%20-%200-5%20Year%20Olds.pdf",
            type: "PDF",
          },
        ],
      },
      {
        name: "Resources for Parents",
        resources: [
          {
            name: "Parent Essentials 1-Pager - Young Adult",
            copy: "A one-page guide with practical steps to help a young adult build and maintain a strong Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Parent%20Essentials%20-%20Young%20Adults.pdf",
            type: "PDF",
          },
          {
            name: "Parent Essentials 1-Pager - High School",
            copy: "A one-page guide with practical steps parents can take to help their high schooler build and sustain a strong Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Parent%20Essentials%20-%20High%20School.pdf",
            type: "PDF",
          },
          {
            name: "Parent Essentials 1-Pager - Middle School",
            copy: "A one-page guide with practical steps parents can take to help their middle schooler build and strengthen a Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Parent%20Essentials%20-%20Middle%20School.pdf",
            type: "PDF",
          },
          {
            name: "Parent Essentials 1-Pager - K-5th Grade",
            copy: "A one-page guide with practical steps parents can take to help their child build a strong Mentor Circle in the elementary years.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Parent%20Essentials%20-%201%20Pager%20-%20K-5th.pdf",
            type: "PDF",
          },
          {
            name: "Parent Essentials: 0-5 Year Olds",
            copy: "A concise guide for parents on practical steps they can take to help their child develop a strong Mentor Circle over time.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Parent%20Essentials%20-%200-5%20Year%20Olds.pdf",
            type: "PDF",
          },
        ],
      },
      {
        name: "Resources for Grandparents",
        resources: [
          {
            name: "Grandparent Essentials 1-Pager - High School",
            copy: "A one-page guide with practical ways grandparents can support a high school student and strengthen their Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Grandparent%20Essentials%20-%20High%20School.pdf",
            type: "PDF",
          },
          {
            name: "Grandparent Essentials 1-Pager - Middle School",
            copy: "A one-page guide with simple, meaningful ways grandparents can encourage a middle schooler and help build a Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Grandparent%20Essentials%20-%20Middle%20School.pdf",
            type: "PDF",
          },
          {
            name: "Grandparent Essentials 1-Pager - K-5th Grade",
            copy: "A one-page guide outlining how grandparents can nurture relationships and support the early growth of a Mentor Circle.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Grandparent%20Essentials%20-%20K%20-%205th%20Grade.pdf",
            type: "PDF",
          },
          {
            name: "Grandparent Essentials: 0-5 Year Olds",
            copy: "A concise guide on how grandparents can help lay the foundation for a strong Mentor Circle in the earliest years.",
            url: "https://encircled-app.nyc3.cdn.digitaloceanspaces.com/resources/Encircled%20Grandparent%20Essentials%20-%200-5%20Year%20Old.pdf",
            type: "PDF",
          },
        ],
      },
    ],
  },
]